export default "__VITE_ASSET__DhZiHjFD__"